<template>
    <div class="container-fluid">
        <div class="row justify-content-center">
            <div class="col-12">
                <!-- Header -->
                <div class="header mt-md-5">
                    <div class="header-body">
                        <div class="row align-items-center">
                            <div class="col">
                                <h6 class="header-pretitle">{{ $t('Company') }}</h6>
                                <h1 class="header-title">{{ $t('Communications') }}</h1>
                            </div>
                            <div class="col-auto"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <!-- Card -->
                <div class="card" data-toggle="lists">
                    <div class="card-header">
                        <div class="row align-items-center">
                            <!-- search -->
                            <div class="col">
                                <!-- Search -->
                                <div class="row align-items-center">
                                    <div class="col-auto pr-0">
                                        <span class="fe fe-x text-muted" v-if="query" @click="query=null"></span>
                                        <span class="fe fe-search text-muted" v-else></span>
                                    </div>
                                    <div class="col">
                                        <!-- <input type="search" class="form-control form-control-flush search no-glow"> -->
                                        <b-form-input
                                            v-model="query"
                                            :autofocus="true"
                                            class="no-glow search form-control-flush"
                                            :placeholder="$t('Search')"
                                        ></b-form-input>
                                    </div>
                                </div>
                            </div>

                            <!-- helper col -->
                            <div class="d-none d-xl-block col"></div>

                            <!-- date filter -->
                            <div class="d-none d-xl-block col-auto">
                                <date-filter v-model="dates"></date-filter>
                            </div>
                            <!--team filter-->
                            <div class="d-none d-xl-block col-auto" v-if="$hasPermission('communications', ['seeAll'])">
                                <team-filter v-model="user"></team-filter>
                            </div>
                            <!-- Per page filter -->
                            <div class="d-none d-xl-block col-auto">
                                <div class="dropdown">
                                    <b-button-group>
                                        <button class="btn btn-white" v-if="selectedPerPage > 0" @click="perPageGenerator(0)">
                                            <span class="fe fe-x"></span>
                                        </button>
                                        <b-dropdown variant="white" right :text="$t('Per page')">
                                            <b-dropdown-item
                                                @click="perPageGenerator(page)"
                                                v-for="(page, index) in perPageLabel"
                                                :key="index"
                                            >{{ page }}</b-dropdown-item>
                                        </b-dropdown>
                                    </b-button-group>
                                </div>
                            </div>

                            <!-- filter button -->
                            <div class="col-auto d-xl-none">
                                <b-button @click="openModal({id:'customerCommunicationModal'})" variant="white" size="md">
                                    <i class="fe fe-filter"></i>
                                </b-button>
                            </div>

                        </div>
                        <!-- / .row -->
                    </div>
                </div>

                <div class="row">
                    <div class="col-xl-3 col-lg-4 col-12">
                        <div class="card">
                            <div class="card-body p-0 p-md-4">
                                <nav
                                    style="border-width: 0;"
                                    class="navbar fixed-start navbar-expand-sm navbar-light position-relative"
                                    :class="$screen.width >= 576 ? 'navbar-vertical' : 'nav-tabs navbar-overflow'"
                                >
                                    <ul class="navbar-nav mb-md-3">
                                        <li class="nav-item" v-for="nav in navs">
                                            <a
                                                href="#"
                                                class="nav-link text-nowrap"
                                                :class="{active:tab === nav.value}"
                                                @click.prevent="tab = nav.value"
                                            >
                                                <i class="fe mr-3 d-none d-md-block" :class="{[nav.icon]: nav.icon}"></i> {{$t(nav.label)}}
                                            </a>
                                        </li>
                                    </ul>
                                </nav>
                            </div>
                        </div>
                    </div>
                    <div class="card col-xl-9 col-lg-8 col-12" v-if="tab === 'telegram' && !isTelegramIntergrated">
                        <div class="card-body col-12 text-center">
                            <h4 class="m-4">
                                {{$t('Telegram integration is not configured')}}
                            </h4>
                            <button class="btn btn-primary" @click.prevent="$router.push({ name: 'company.profile.integrations' })">
                                {{$t('Configure')}}
                            </button>
                        </div>
                    </div>
                    <div class="col-xl-9 col-lg-8 col-12" v-else>
                        <div v-if="areCommunicationsLoading">
                            <div class="card">
                                <div class="card-body d-flex justify-content-center">
                                    <b-spinner variant="primary" label="Spinning"></b-spinner>
                                </div>
                            </div>
                        </div>

                        <div v-else>
                            <div v-if="communications.length === 0">
                                <div class="card card-inactive">
                                    <div class="card-body text-center text-muted">{{ $t('Nothing yet')}}</div>
                                </div>
                            </div>

                            <div v-else>
                                <div class="card desk32-messenger">
                                    <div class="card-body">
                                        <communication-item :withCustomer="true" v-for="(item, index) in communications" :key="index" class="mt-2" :item="item"></communication-item>
                                    </div>
                                </div>

                                <div class="row justify-content-center mt-3 mb-3" v-if="totalRows > perPage">
                                    <b-pagination page-class="page-item" :total-rows="totalRows" v-model="currentPage" :per-page="perPage" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <mobile-filters-modal id="customerCommunicationModal">
                <!-- team filter -->
                <div class="col-12 mb-3">
                    <team-filter v-model="user"></team-filter>
                </div>

                <!-- date filter -->
                <div class="col-12 mb-3">
                    <date-filter v-model="dates"></date-filter>
                </div>

                <!-- Per page filter -->
                <div class="col-12 mb-3">
                    <div class="dropdown">
                        <b-button-group>
                            <button class="btn btn-white" v-if="selectedPerPage > 0" @click="perPageGenerator(0)">
                                <span class="fe fe-x"></span>
                            </button>
                            <b-dropdown variant="white" right :text="$t('Per page')">
                                <b-dropdown-item
                                    @click="perPageGenerator(page)"
                                    v-for="(page, index) in perPageLabel"
                                    :key="index"
                                >{{ page }}</b-dropdown-item>
                            </b-dropdown>
                        </b-button-group>
                    </div>
                </div>
            </mobile-filters-modal>
        </div>
    </div>
</template>

<script>
import { modalMixins } from '@/mixins/modal.js'
import {mapActions, mapGetters, mapState} from 'vuex'
import debounce from 'lodash/debounce';
import TeamFilter from "@/components/TeamFilter";
import DateFilter from "@/components/DateFilter";
import CommunicationItem from "@/Pages/People/Customer/Communications/CommunicationItem";
import mobileFiltersModal from "@/components/mobileFiltersModal";

export default {
    props: ['customerId'],
    mixins: [modalMixins],
    components: {
        TeamFilter,
        DateFilter,
        CommunicationItem,
        mobileFiltersModal
    },
    data() {
        return {
            dates: {},
            user: [],
            params: {
                query: {
                    $sort: { scheduledTo: -1, createdAt: -1 },
                    status: { $ne: 'scheduled' }
                }
            },
            tab: '',
            query: null,
            perPageLabel: [5, 10, 20, 50, 100],
            selectedPerPage: null,
            currentPage: 1,
            perPage: 20,
            totalRows: 0,
            navs: [
                {
                    label: 'All',
                    value: '',
                    icon: 'fe-list'
                },
                {
                    label: 'Scheduled',
                    value: 'scheduled',
                    icon: 'fe-clock',
                },
                {
                    label: 'Recent Calls',
                    value: 'phone',
                    icon: 'fe-phone'
                },
                {
                    label: 'SMS Messages',
                    value: 'sms',
                    icon: 'fe-message-square'
                },
                {
                    label: 'Email',
                    value: 'email',
                    icon: 'fe-mail'
                },
                {
                    label: 'Telegram',
                    value: 'telegram',
                    icon: 'fe-send'
                },
            ]
        }
    },
    watch: {
        query: debounce(function (newVal) {
            if (newVal) {
                this.params.query.$or = [
                    { body: { $regex: newVal, $options: "i" } },
                ];
            } else {
                delete this.params.query.$or;
            }
            this.fetchCommunications();
        }, 400),
        user: debounce(function (newVal) {
            if (newVal.length)
                this.params.query.userId = { $in: newVal };
            else
                delete this.params.query.userId;
            this.fetchCommunications();
        }, 400),
        dates: debounce(function (newVal) {
            if (newVal.start)
                this.params.query.createdAt = { $lte: this.dates.end, $gte: this.dates.start };
            else
                delete this.params.query.createdAt
            this.fetchCommunications();
        }, 400),
        tab: debounce(function (newVal) {
            if (newVal && newVal !== 'scheduled') {
                this.params.query.transport = newVal;
                this.currentPage = 1;
                delete this.params.query.status
            } else if ( newVal === 'scheduled' ) {
                this.params.query.status = 'scheduled';
                delete this.params.query.transport
            } else {
                delete this.params.query.transport
                this.params.query.status = {$ne: 'scheduled'}
            }
            this.fetchCommunications();
        }, 400),
        currentPage: debounce(function (newVal) {
            this.fetchCommunications();
        }, 400)
    },
    computed: {
        ...mapGetters('communications', {
            findItemsInStore: 'find'
        }),
        ...mapState('communications', { areCommunicationsLoading: 'isFindPending' }),
        ...mapGetters('customers', {
            getCustomerFromStore: 'get'
        }),
        ...mapGetters('my-company', {
            getMyCompanyFromStore: 'get'
        }),

        customer() {
            return this.getCustomerFromStore(this.$route.params.id);
        },
        communications() {
            return this.findItemsInStore(this.params).data;
        },
        myCompany(){
            return this.getMyCompanyFromStore('mine') || {};
        },

        isTelegramIntergrated() {
            return this.myCompany && this.myCompany.telegram && this.myCompany.telegram.phone;
        },
    },
    created() {
        this.fetchCommunications();
        this.getMyCompany(['mine', { skipRequestIfExists: false }]);
    },
    methods: {
        ...mapActions('communications', ['find']),
        ...mapActions('my-company', {getMyCompany: 'get'}),

        fetchCommunications() {
            this.params.query.$limit = this.perPage;
            this.params.query.$skip = (this.currentPage - 1) * this.perPage;
            this.params.query.$sort = { createdAt: -1 };

            this.find(this.params)
                .then( data => {
                    this.totalRows = data.total;
                })
                .catch( err => {
                    console.log(err)
                })
        },

        openActionWindow(data) {
            let details = {
                model: data,
                _id: 'temp'
            }
            const { Communication } = this.$FeathersVuex;
            new Communication(details);
            this.openModal({ id: 'CommunicationsModal' });
        },
        perPageGenerator(perPage) {
            this.currentPage = 1;
            this.selectedPerPage = perPage;
            if (perPage > 0)
                this.perPage = perPage;
            else {
                this.perPage = 20;
                this.selectedPerPage = 0;
            }
            this.fetchCommunications();
        },


    },

}
</script>

<style lang="scss" scoped>
    .navbar-collapse.show::before {
        display: none;
    }
    .navbar[class*="fixed-"] {
        z-index: 1!important;
    }
</style>
